"use client";

import type { ReactNode } from "react";
import { GameIconButton } from "./GameIconButton";

interface GameScreenHeaderProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  actions?: ReactNode;
}

export function GameScreenHeader({ title, subtitle, onBack, actions }: GameScreenHeaderProps) {
  return (
    <header className="mb-4 flex items-start gap-3">
      {onBack ? <GameIconButton icon="back" tone="slate" size="md" onClick={onBack} /> : null}
      <div className="min-w-0 flex-1 pt-1">
        <h1 className="text-2xl font-extrabold text-white drop-shadow-[0_2px_0_rgba(0,0,0,0.45)] sm:text-3xl">
          {title}
        </h1>
        {subtitle ? <p className="mt-1 text-sm font-semibold text-violet-100/90">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 gap-2">{actions}</div> : null}
    </header>
  );
}
